/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import moment from 'moment';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';

import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { contractsUsingContactHead } from './gridComponents/tableHead';

const ContractsUsingContactModal = (props) => {
  const { data } = props;
  const [rowData] = React.useState(data);
  const [columnDefs] = React.useState(contractsUsingContactHead);
  // Ag-grid FrameworkComponent
  const frameworkComponents = {
    StartDate: (cellInfo) => {
      if (cellInfo.value !== null && cellInfo.value !== '') {
        return (
          <div className="tdCell icon-btn-group">
            <span className="td-date-range">
              {moment(cellInfo.value).format('MM/DD/YYYY')}
              {'   '} <SVGComponent iconName="Icon_date-range" />
            </span>
          </div>
        );
      }
      return null;
    },
    EndDate: (cellInfo) => {
      if (cellInfo.value !== null && cellInfo.value !== '') {
        return (
          <div className="tdCell icon-btn-group">
            <span className="td-date-range">
              {moment(cellInfo.value).format('MM/DD/YYYY')}
              {'   '} <SVGComponent iconName="Icon_date-range" />
            </span>
          </div>
        );
      }
      return null;
    },
    contractNameRender: (cellInfo) => {
      const name = cellInfo.data.contractName;
      if (name && name.length > 23) {
        return (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
          >
            <div>{name}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
  };
  return (
    <>
      <div
        className="panel-header mui-custom-form"
        data-testid="contract-using-contact-popup"
      >
        <TableGrid
          gridHeight={350}
          rowData={rowData}
          columnDefs={columnDefs}
          navigateToNextCell={navigateToNextCell}
          // tabToNextCell={tabToNextCell}
          enterMovesDown
          suppressCellFocus
          onCellFocused={onCellFocused}
          applyFilter={false}
          exportFile
          childPopup
          helpMessage=""
          data-testid="onEditingStopped"
          fileName="Contracts using contact"
          frameworkComponents={frameworkComponents}
        />
      </div>
    </>
  );
};
export default ContractsUsingContactModal;
